(function () {
    'use strict';

    var homeNav1 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/layouts/navbar/home-nav1.html',
        controllerAs: 'vm',
        bindings: {
            current: '<',
        },
        controller: ['$state', 'Auth', 'Principal',
            function ($state, Auth, Principal) {
                var vm = this;
                vm.isNavbarCollapsed = true;
                vm.isAuthenticated = Principal.isAuthenticated;
            }]
    };

    angular
        .module('platformApp')
        .component('homeNav1', homeNav1);
})();
